<template>
    <section id="team" class="section team-area ptb_100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-6">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-capitalize">What our users say</h2>
                        <p class="mt-4">See how professionals worldwide are simplifying expense management with Forward Receipt.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Team Slider -->
                <div class="team-slider owl-carousel">
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Sarah L.</h3>
                            <h5 class="team-post mb-2">Marketing Manager</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">Forward Receipt completely changed how I handle expenses. I just take a photo, and everything else is done automatically.</p>
                        </div>
                    </div>
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Daniel K.</h3>
                            <h5 class="team-post mb-2">Startup Founder</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">Perfect for our small team! The shared organization feature keeps everyone on the same page.</p>
                        </div>
                    </div>
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Emily T.</h3>
                            <h5 class="team-post mb-2">Freelancer</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">I used to spend hours entering receipts manually. Now everything is recognized by AI in seconds. A brilliant tool.</p>
                        </div>
                    </div>
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Luca M.</h3>
                            <h5 class="team-post mb-2">Consultant</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">The multi-currency support is a lifesaver on my business trips. Everything is converted instantly.</p>
                        </div>
                    </div>
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Jasmine R.</h3>
                            <h5 class="team-post mb-2">Finance Assistant</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">Simple, accurate, and free — I couldn't ask for a better expense management app.</p>
                        </div>
                    </div>
                    <!-- Single Team -->
                    <div class="single-team text-center px-3 py-2 m-2">
                        <!-- Team Content -->
                        <div class="team-content mt-2 mb-1">
                            <h3 class="team-name mt-3 mb-2">Li Wei</h3>
                            <h5 class="team-post mb-2">CFO Assistant</h5>
                            <div class="client-rating mb-1">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                            <p class="team-description">I love how easy it is to manage our team's receipts. It's incredibly convenient for small businesses.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>